<template>
    <div :class="formRowClass">
        <div
            v-if="title && stringIsNotEmpty(title)"
            class="form-row__title"
        >
            <zoe-atom-text :item="title" />
        </div>

        <label
            v-if="label"
            class="hidden-label"
            :for="name"
        >
            {{ label }}
        </label>

        <slot />

        <zoe-form-pre-validate-icon
            v-if="useValidation"
            :name="name"
            :valid="preValid"
        />
    </div>
</template>

<script>
import ZoeFormPreValidateIcon from '../../../form/fields/pre-validate-icon/v1.0.0/zoe-form-pre-validate-icon.vue';
import ZoeAtomText from '../../../atoms/text/v1.0.0/zoe-atom-text.vue';
import Page from '../../../../../../resources/frontend/js/mixins/page.vue';

export default {
    components: {
        ZoeAtomText,
        ZoeFormPreValidateIcon,
    },

    mixins: [Page],

    props: {
        index: {
            type: Number,
            required: false,
            default: null,
        },

        name: {
            type: String,
            required: false,
            default: '',
        },

        useValidation: {
            type: Boolean,
            required: false,
            default: false,
        },

        preValid: {
            type: Boolean,
            required: false,
            default: null,
        },

        valid: {
            type: Boolean,
            required: false,
            default: null,
        },

        extraClasses: {
            type: Array,
            required: false,
            default: () => [],
        },

        label: {
            type: String,
            required: false,
            default: '',
        },

        title: {
            type: String,
            required: false,
            default: '',
        },
    },

    computed: {
        formRowClass() {
            let $class = 'form-row';

            if (this.index) $class += ` form-row-${this.index + 1}`;

            if (this.name) $class += ` form-row-${this.name}`;

            if (this.useValidation) {
                if (this.preValid === true) {
                    $class += ' form-row--pre-validate-valid';
                } else if (this.preValid === false) {
                    $class += ' form-row--pre-validate-invalid';
                }

                if (this.valid === true) {
                    $class += ' form-row--valid';
                } else if (this.valid === false) {
                    $class += ' form-row--invalid';
                }
            }

            for (const extraClass of this.extraClasses) {
                $class += ` form-row-${extraClass}`;
            }

            return $class;
        },
    },
};
</script>
